module.exports = __webpack_public_path__ + "media/svg/exclamation-6b9f40da.svg";